import { configureStore,combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import authenticationReducer from '../features/authentication/authenticationReducer'
import coreReducer  from '../features/core/coreReducer'
const rootReducer = combineReducers({
  authenticationReducer,
  coreReducer
})
const persistConfig = {
  key: 'root',
  storage,
  version:1
}
const persistedReducer = persistReducer(persistConfig, rootReducer)
export const store = configureStore({
  reducer: persistedReducer,
  middleware:(getDefaultMiddleware)=>getDefaultMiddleware({
    serializableCheck:false
  })
})
export const persistor = persistStore(store)